import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { useBooking } from "@/lib/booking";

// Slow editorial outline-text marquee.
export const EditorialMarquee = ({ text = "SEO · AEO · GEO · CONTENT THAT COMPOUNDS", speed = 22 }) => (
  <div data-testid="editorial-marquee" className="py-10 md:py-14 border-y border-[#E0E0E0] overflow-hidden">
    <Marquee speed={speed} gradient={false}>
      {Array.from({ length: 4 }).map((_, i) => (
        <span
          key={i}
          className="text-outline font-serif italic text-6xl md:text-8xl lg:text-9xl mx-8 whitespace-nowrap"
        >
          {text}
        </span>
      ))}
    </Marquee>
  </div>
);

// Reusable footer CTA band (dark).
export const CTABand = ({
  eyebrow = "Ready when you are",
  heading = "Let's build your acquisition engine.",
  showSecondary = true,
  showCaseStudies = false,
}) => {
  const { openBooking } = useBooking();
  return (
    <section data-testid="cta-band" className="bg-[#111111] text-white section-pad">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#666666] mb-6">{eyebrow}</p>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.05] max-w-4xl">
            {heading}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col sm:flex-row flex-wrap gap-4">
            <button
              type="button"
              onClick={openBooking}
              data-testid="ctaband-primary"
              className="inline-flex items-center gap-2 bg-white text-[#111111] font-semibold px-8 py-4 hover:bg-[#E0E0E0] transition-colors group"
            >
              Schedule a Content Audit
              <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
            </button>
            {showSecondary && (
              <Link
                to="/contact"
                data-testid="ctaband-secondary"
                className="inline-flex items-center gap-2 border border-[#666666] text-white font-semibold px-8 py-4 hover:bg-white hover:text-[#111111] transition-colors"
              >
                Talk to Us
              </Link>
            )}
            {showCaseStudies && (
              <Link
                to="/case-studies"
                data-testid="ctaband-cases"
                className="inline-flex items-center gap-2 border border-[#666666] text-white font-semibold px-8 py-4 hover:bg-white hover:text-[#111111] transition-colors"
              >
                View Case Studies
              </Link>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
